export default {
  getSnackbar: (state) => {
    return state.snackbar
  },
  getPopup: (state) => {
    return state.popup
  },
  getMainActiveService: (state) => {
    return state.mainActiveService
  },
  getUsernameCache: (state) => {
    return state.usernameCache
  },
  getCurrency: (state) => {
    return state.currency
  },
  getRates: (state) => {
    return state.rates
  },
  getRatesLastUpdated: (state) => {
    return state.ratesLastUpdated
  }
}
